<template>
<listp type="removed_findings" />
</template>
<script>
import listp from '@/modules/CA_SP/components/actions/list.vue';
export default { components: { listp } };
</script>
